"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterFields = getFilterFields;
/**
 * Traverse filterGroups to get all the filter fields as an array
 * Optionally set `includeFilterValue` to true for an array of `{filterField:filterValue}` objects
 */
function getFilterFields(groups, includeFilterValue) {
  var filterFields = new Set();
  if (Array.isArray(groups)) {
    groups.filter(function (group) {
      return group;
    }).forEach(function (group) {
      if (Array.isArray(group.filters)) {
        group.filters.filter(function (filter) {
          return filter;
        }).forEach(function (filter) {
          if (includeFilterValue) {
            var filterField = filter.filterField,
              filterValue = filter.filterValue;
            filterFields.add({
              filterField: filterField,
              filterValue: filterValue
            });
          } else {
            filterFields.add(filter.filterField);
          }
        });
        getFilterFields(group.filterGroups || [], includeFilterValue).filter(function (filter) {
          return filter;
        }).forEach(function (field) {
          return filterFields.add(field);
        });
      }
    });
  }
  return Array.from(filterFields);
}